/**
 * Kanban CSS Constants
 */
/** @private */
export const ROOT_CLASS = 'e-kanban';
/** @private */
export const RTL_CLASS = 'e-rtl';
/** @private */
export const DEVICE_CLASS = 'e-device';
/** @private */
export const ICON_CLASS = 'e-icons';
/** @private */
export const TEMPLATE_CLASS = 'e-template';
/** @private */
export const SWIMLANE_CLASS = 'e-swimlane';
/** @private */
export const TABLE_CLASS = 'e-kanban-table';
/** @private */
export const HEADER_CLASS = 'e-kanban-header';
/** @private */
export const HEADER_TABLE_CLASS = 'e-header-table';
/** @private */
export const HEADER_CELLS_CLASS = 'e-header-cells';
/** @private */
export const HEADER_WRAP_CLASS = 'e-header-wrap';
/** @private */
export const HEADER_TITLE_CLASS = 'e-header-title';
/** @private */
export const HEADER_TEXT_CLASS = 'e-header-text';
/** @private */
export const HEADER_ICON_CLASS = 'e-header-icon';
/** @private */
export const STACKED_HEADER_ROW_CLASS = 'e-stacked-header-row';
/** @private */
export const STACKED_HEADER_CELL_CLASS = 'e-stacked-header-cell';
/** @private */
export const CONTENT_CELLS_CLASS = 'e-content-cells';
/** @private */
export const CONTENT_CLASS = 'e-kanban-content';
/** @private */
export const CONTENT_TABLE_CLASS = 'e-content-table';
/** @private */
export const HEADER_ROW_TOGGLE_CLASS = 'e-toggle-header';
/** @private */
export const HEADER_ROW_CLASS = 'e-header-row';
/** @private */
export const CONTENT_ROW_CLASS = 'e-content-row';
/** @private */
export const SWIMLANE_ROW_CLASS = 'e-swimlane-row';
/** @private */
export const SWIMLANE_ROW_EXPAND_CLASS = 'e-swimlane-row-expand';
/** @private */
export const SWIMLANE_ROW_COLLAPSE_CLASS = 'e-swimlane-row-collapse';
/** @private */
export const SWIMLANE_ROW_TEXT_CLASS = 'e-swimlane-text';
/** @private */
export const CARD_ITEM_COUNT_CLASS = 'e-item-count';
/** @private */
export const CARD_WRAPPER_CLASS = 'e-card-wrapper';
/** @private */
export const CARD_VIRTUAL_WRAPPER_CLASS = 'e-card-virtual-wrapper';
/** @private */
export const CARD_CLASS = 'e-card';
/** @private */
export const DRAGGABLE_CLASS = 'e-draggable';
/** @private */
export const DROPPABLE_CLASS = 'e-droppable';
/** @private */
export const DRAG_CLASS = 'e-drag';
/** @private */
export const DROP_CLASS = 'e-drop';
/** @private */
export const DISABLED_CLASS = 'e-disabled';
/** @private */
export const CARD_HEADER_CLASS = 'e-card-header';
/** @private */
export const CARD_CONTENT_CLASS = 'e-card-content';
/** @private */
export const CARD_HEADER_TEXT_CLASS = 'e-card-header-caption';
/** @private */
export const CARD_HEADER_TITLE_CLASS = 'e-card-header-title';
/** @private */
export const CARD_TAGS_CLASS = 'e-card-tags';
/** @private */
export const CARD_TAG_CLASS = 'e-card-tag';
/** @private */
export const CARD_COLOR_CLASS = 'e-card-color';
/** @private */
export const CARD_LABEL_CLASS = 'e-card-label';
/** @private */
export const CARD_FOOTER_CLASS = 'e-card-footer';
/** @private */
export const EMPTY_CARD_CLASS = 'e-empty-card';
/** @private */
export const CARD_FOOTER_CSS_CLASS = 'e-card-footer-css';
/** @private */
export const COLUMN_EXPAND_CLASS = 'e-column-expand';
/** @private */
export const COLUMN_COLLAPSE_CLASS = 'e-column-collapse';
/** @private */
export const COLLAPSE_HEADER_TEXT_CLASS = 'e-collapse-header-text';
/** @private */
export const COLLAPSED_CLASS = 'e-collapsed';
/** @private */
export const DIALOG_CLASS = 'e-kanban-dialog';
/** @private */
export const DIALOG_CONTENT_CONTAINER_CLASS = 'e-kanban-dialog-content';
/** @private */
export const FORM_CLASS = 'e-kanban-form';
/** @private */
export const FORM_WRAPPER_CLASS = 'e-kanban-form-wrapper';
/** @private */
export const ERROR_VALIDATION_CLASS = 'e-kanban-error';
/** @private */
export const FIELD_CLASS = 'e-field';
/** @private */
export const DRAGGED_CLONE_CLASS = 'e-target-dragged-clone';
/** @private */
export const CLONED_CARD_CLASS = 'e-cloned-card';
/** @private */
export const DRAGGED_CARD_CLASS = 'e-kanban-dragged-card';
/** @private */
export const DROPPED_CLONE_CLASS = 'e-target-dropped-clone';
/** @private */
export const DROPPING_CLASS = 'e-dropping';
/** @private */
export const BORDER_CLASS = 'e-kanban-border';
/** @private */
export const TOGGLE_VISIBLE_CLASS = 'e-toggle-visible';
/** @private */
export const MULTI_CLONE_CONTENT_CELL_CLASS = 'e-multi-content-cell';
/** @private */
export const MULTI_CARD_WRAPPER_CLASS = 'e-multi-card-wrapper';
/** @private */
export const MULTI_ACTIVE_CLASS = 'e-multi-active';
/** @private */
export const TARGET_MULTI_CLONE_CLASS = 'e-target-multi-clone';
/** @private */
export const MULTI_COLUMN_KEY_CLASS = 'e-column-key';
/** @private */
export const CARD_SELECTION_CLASS = 'e-selection';
/** @private */
export const TOOLTIP_CLASS = 'e-kanban-tooltip';
/** @private */
export const TOOLTIP_TEXT_CLASS = 'e-tooltip-text';
/** @private */
export const SCROLL_CONTAINER_CLASS = 'e-cell-scroll-container';
/** @private */
export const SWIMLANE_HEADER_CLASS = 'e-swimlane-header';
/** @private */
export const SWIMLANE_HEADER_TOOLBAR_CLASS = 'e-swimlane-header-toolbar';
/** @private */
export const TOOLBAR_MENU_CLASS = 'e-toolbar-menu';
/** @private */
export const TOOLBAR_MENU_ICON_CLASS = 'e-icon-menu';
/** @private */
export const TOOLBAR_LEVEL_TITLE_CLASS = 'e-toolbar-level-title';
/** @private */
export const TOOLBAR_SWIMLANE_NAME_CLASS = 'e-toolbar-swimlane-name';
/** @private */
export const SWIMLANE_OVERLAY_CLASS = 'e-swimlane-overlay';
/** @private */
export const SWIMLANE_CONTENT_CLASS = 'e-swimlane-content';
/** @private */
export const SWIMLANE_RESOURCE_CLASS = 'e-swimlane-resource';
/** @private */
export const SWIMLANE_TREE_CLASS = 'e-swimlane-tree';
/** @private */
export const LIMITS_CLASS = 'e-limits';
/** @private */
export const MAX_COUNT_CLASS = 'e-max-count';
/** @private */
export const MIN_COUNT_CLASS = 'e-min-count';
/** @private */
export const MAX_COLOR_CLASS = 'e-max-color';
/** @private */
export const MIN_COLOR_CLASS = 'e-min-color';
/** @private */
export const POPUP_EVENT_CLASS = 'e-event-popup';
/** @private */
export const POPUP_HEADER_CLASS = 'e-popup-header';
/** @private */
export const CLOSE_CLASS = 'e-close';
/** @private */
export const POPUP_CONTENT_CLASS = 'e-popup-content';
/** @private */
export const POPUP_WRAPPER_CLASS = 'e-mobile-popup-wrapper';
/** @private */
export const CLOSE_ICON_CLASS = 'e-close-icon';
/** @private */
export const POPUP_OPEN_CLASS = 'e-popup-open';
/** @private */
export const DIALOG_CONTENT_CONTAINER = 'e-kanban-dialog-content';
/** @private */
export const SHOW_ADD_BUTTON = 'e-show-add-button';
/** @private */
export const SHOW_ADD_ICON = 'e-show-add-icon';
/** @private */
export const SHOW_ADD_FOCUS = 'e-show-add-focus';
/** @private */
export const FROZEN_SWIMLANE_ROW_CLASS = 'e-frozen-swimlane-row';
/** @private */
export const FROZEN_ROW_CLASS = 'e-frozen-row';
/** @private */
export const TOOLBAR_SWIMLANE_ITEM_COUNT_CLASS = 'e-toolbar-swimlane-item-count';
